// extracted by mini-css-extract-plugin
export default {"caption":"SLBPuMFF","credits":"z01RNUZx"};